module.exports = __webpack_public_path__ + "static/media/the-huffington-post.ebe8cb39.jpg";